"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _reactDom = require("react-dom");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _moment = _interopRequireDefault(require("moment"));

var _classnames = _interopRequireDefault(require("classnames"));

var _CwButton = _interopRequireDefault(require("../../cwbutton/CwButton"));

var _CwImage = _interopRequireDefault(require("../../cwimage/CwImage"));

var _CwLabel = _interopRequireDefault(require("../../cwlabel/CwLabel"));

var _CwTimeField = _interopRequireDefault(require("../../cwtimefield/CwTimeField"));

var _reactPopper = require("react-popper");

var _IconPath = _interopRequireDefault(require("../../../utils/IconPath"));

var _CwDataGrid = _interopRequireDefault(require("../CwDataGrid.scss"));

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var TimeFilter =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(TimeFilter, _React$Component);
  (0, _createClass2.default)(TimeFilter, null, [{
    key: "formatTime",
    value: function formatTime(time) {
      var tf = new Intl.DateTimeFormat('en-US', {
        hour: 'numeric',
        minute: 'numeric'
      });
      return tf.format((0, _moment.default)(time));
    }
  }, {
    key: "getBlankFilterValue",
    value: function getBlankFilterValue() {
      return {
        startTime: null,
        endTime: null
      };
    }
  }]);

  function TimeFilter() {
    var _this;

    (0, _classCallCheck2.default)(this, TimeFilter);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(TimeFilter).call(this));
    _this.state = {
      showDropdown: false,
      endTimeFocused: false,
      startTimeFocused: false,
      valueWidth: 100
    };
    _this.handleDocumentClick = _this.handleDocumentClick.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(TimeFilter, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('click', this.handleDocumentClick);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var timeFilter = (0, _reactDom.findDOMNode)(this.timeFilter);

      if (timeFilter) {
        var valueWidth = timeFilter.clientWidth - 40;

        if (this.state.valueWidth !== valueWidth) {
          this.setState({
            valueWidth: valueWidth
          });
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('click', this.handleDocumentClick);
    }
  }, {
    key: "onFilterChange",
    value: function onFilterChange(key, value) {
      this.props.onFilterChange(_objectSpread({}, this.props.filterValue, (0, _defineProperty2.default)({}, key, value)));
    }
  }, {
    key: "setShowDropdown",
    value: function setShowDropdown(showDropdown) {
      this.setState({
        showDropdown: showDropdown
      });
    }
  }, {
    key: "setEndTimeFocused",
    value: function setEndTimeFocused(endTimeFocused) {
      this.setState({
        endTimeFocused: endTimeFocused
      });
    }
  }, {
    key: "setStartTimeFocused",
    value: function setStartTimeFocused(startTimeFocused) {
      this.setState({
        startTimeFocused: startTimeFocused
      });
    }
  }, {
    key: "handleDocumentClick",
    value: function handleDocumentClick(event) {
      var timeFilter = (0, _reactDom.findDOMNode)(this.timeFilter);

      if (timeFilter && !timeFilter.contains(event.target)) {
        this.setShowDropdown(false);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var timeFilterValueString = '';

      if (this.props.filterValue.startTime || this.props.filterValue.endTime) {
        timeFilterValueString = this.props.filterValue.startTime ? this.props.filterValue.startTime.format('h:mm a') : '12:00 am';
        timeFilterValueString += ' - ';
        timeFilterValueString += this.props.filterValue.endTime ? this.props.filterValue.endTime.format('h:mm a') : '11:59 pm';
      }

      return _react.default.createElement(_reactPopper.Manager, {
        ref: function ref(c) {
          _this2.timeFilter = c;
        }
      }, _react.default.createElement(_reactPopper.Target, {
        style: {
          position: 'relative'
        }
      }, _react.default.createElement(_CwButton.default, {
        cwId: "".concat(this.props.cwId, "_column_").concat(this.props.column.key, "_filter"),
        value: "",
        className: _CwDataGrid.default.timeFilterButton,
        rightIcon: this.props.column.triggerIcon,
        onClick: function onClick() {
          _this2.setShowDropdown(!_this2.state.showDropdown);
        }
      }), _react.default.createElement("div", {
        "data-cwid": "".concat(this.props.cwId, "_column_").concat(this.props.column.key, "_filter_value"),
        className: _CwDataGrid.default.timeFilterValue,
        style: {
          width: this.state.valueWidth
        },
        title: timeFilterValueString,
        onClick: function onClick() {
          _this2.setShowDropdown(!_this2.state.showDropdown);
        }
      }, timeFilterValueString)), this.state.showDropdown && _react.default.createElement(_reactPopper.Popper, {
        placement: "bottom-start",
        style: {
          zIndex: 1
        },
        positionFixed: true
      }, _react.default.createElement("div", {
        className: _CwDataGrid.default.columnFilterDropdown
      }, _react.default.createElement("div", {
        style: {
          position: 'relative'
        }
      }, _react.default.createElement(_CwLabel.default, {
        "data-cwid": "".concat(this.props.cwId, "_start_time_label"),
        className: (0, _classnames.default)(_CwDataGrid.default.columnFilterDropdownHeader, (0, _defineProperty2.default)({}, _CwDataGrid.default.focused, this.state.startTimeFocused)),
        value: "Start Time"
      }), _react.default.createElement(_CwTimeField.default, {
        cwId: "".concat(this.props.cwId, "_start_time_value"),
        value: this.props.filterValue.startTime,
        formatTime: TimeFilter.formatTime,
        onChange: function onChange(value) {
          _this2.onFilterChange('startTime', value);
        },
        onBlur: function onBlur() {
          _this2.setStartTimeFocused(false);
        },
        onFocus: function onFocus() {
          _this2.setStartTimeFocused(true);
        },
        autoFocus: true
      }), _react.default.createElement(_CwImage.default, {
        cwId: "".concat(this.props.cwId, "_start_time_icon"),
        className: _CwDataGrid.default.columnFilterFieldIcon,
        src: _IconPath.default.get('Application_Time')
      })), _react.default.createElement("div", {
        style: {
          position: 'relative',
          marginTop: 38
        }
      }, _react.default.createElement(_CwLabel.default, {
        "data-cwid": "".concat(this.props.cwId, "_end_time_label"),
        className: (0, _classnames.default)(_CwDataGrid.default.columnFilterDropdownHeader, (0, _defineProperty2.default)({}, _CwDataGrid.default.focused, this.state.endTimeFocused)),
        value: "End Time"
      }), _react.default.createElement(_CwTimeField.default, {
        cwId: "".concat(this.props.cwId, "_end_time_value"),
        value: this.props.filterValue.endTime,
        formatTime: TimeFilter.formatTime,
        onChange: function onChange(value) {
          _this2.onFilterChange('endTime', value);
        },
        onBlur: function onBlur() {
          _this2.setEndTimeFocused(false);
        },
        onFocus: function onFocus() {
          _this2.setEndTimeFocused(true);
        }
      }), _react.default.createElement(_CwImage.default, {
        cwId: "".concat(this.props.cwId, "_end_time_icon"),
        className: _CwDataGrid.default.columnFilterFieldIcon,
        src: _IconPath.default.get('Application_Time')
      })))));
    }
  }]);
  return TimeFilter;
}(_react.default.Component);

TimeFilter.propTypes = {
  cwId: _propTypes.default.string.isRequired,
  column: _propTypes.default.object.isRequired,
  filterValue: _propTypes.default.object.isRequired,
  onFilterChange: _propTypes.default.func.isRequired
};
var _default = TimeFilter;
exports.default = _default;